import { PlusInSquareIcon } from "assets/icons";
import { useBoolean } from "hooks";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useState } from "react";
import { Button, Pagination, SearchInput } from "ui";

import {
  SASCouponsTable,
  DeleteCouponModal,
  CouponModal
} from "../../components";
import { CouponType } from "../../constants";
import { useCouponsList } from "../../hooks";

import styles from "./SpendAndSaveCoupons.module.scss";

const SpendAndSaveCoupons = () => {
  const {
    coupons,
    totalItems,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useCouponsList(CouponType.SpendAndSaveCoupon);

  const [deletingCouponId, setDeletingCouponId] = useState<string | null>(null);
  const {
    value: isCouponModalOpen,
    setTrue: openCouponModal,
    setFalse: closeCouponModal
  } = useBoolean(false);

  return (
    <ContentLayout title={"Spend & Save Coupons"}>
      <BoxShadowLayout className={styles.pageContent}>
        <div className={styles.pageContent_tableHeaderControls}>
          <SearchInput
            value={searchValue}
            onChange={setSearchValue}
            placeholder={"Search..."}
          />

          <Button
            title={"New Coupon"}
            icon={<PlusInSquareIcon />}
            onClick={openCouponModal}
          />
        </div>

        <div className={styles.pageContent_tableContainer}>
          <SASCouponsTable
            coupons={coupons}
            sorting={sorting}
            setSorting={setSorting}
            isLoading={isLoading}
            onDeleteCoupon={setDeletingCouponId}
          />
        </div>

        <Pagination
          currentPage={page}
          onChange={setPage}
          totalItems={totalItems}
        />
      </BoxShadowLayout>

      <CouponModal
        couponType={CouponType.SpendAndSaveCoupon}
        isOpen={isCouponModalOpen}
        onClose={closeCouponModal}
      />

      {deletingCouponId && (
        <DeleteCouponModal
          id={deletingCouponId}
          isOpen={!!deletingCouponId}
          couponType={CouponType.SpendAndSaveCoupon}
          onClose={() => setDeletingCouponId(null)}
        />
      )}
    </ContentLayout>
  );
};

export default SpendAndSaveCoupons;
